var _style, _path, _defs, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none;stroke:#fff;stroke-width:6;stroke-linecap:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.8 20.4c-3.8-2.9-8.6-4.6-13.7-4.6H39.4c-12.5 0-22.7 10.2-22.7 22.7V48m5.2 27.7c4.2 5 10.4 8.2 17.5 8.2h22.7c12.5 0 22.7-10.2 22.7-22.7v-8.6M39.3 31.4h1.1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-2.3 12h105.5v75.7H-2.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142149393015761519100000003005756044465292170_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000142149393015761519100000003005756044465292170_)",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "m11.9 67.5 24.6-20.7m16.2 13.1L89 29.5"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.3 58.4 37.5 46.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreTrade);
export default __webpack_public_path__ + "static/media/exploreTrade.0c48e990e61bf16da432ca7ef80b491e.svg";
export { ForwardRef as ReactComponent };